import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-30px symbol-md-40px" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/avatars/avatar.png",
    alt: "Usuario"
  })
], -1)
const _hoisted_2 = { class: "d-none d-lg-flex flex-column" }
const _hoisted_3 = { class: "text-gray-900 fs-5 fw-bold" }
const _hoisted_4 = { class: "text-gray-600 fw-semibold fs-7" }

import FamiliasModule from "@/store/modules/FamiliasModule";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const familiaModule = getModule(FamiliasModule, store);

const familia = computed(() => familiaModule.familia);

const onPerfilClick = () => {
  router.push({ name: "perfil" });
};

return (_ctx: any,_cache: any) => {
  return (_unref(familia))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "d-flex flex-row gap-2 cursor-pointer",
        onClick: onPerfilClick
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(familia).nombre) + " " + _toDisplayString(_unref(familia).apellidos), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(familia).email), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})